import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';
import ImageShow from '../../../Uitiles/ImageShow';
import { getSettings } from '../../../services/settingsService';
import './ForgetPassword.css';

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({});
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
    }, []);

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous errors
        setError('');

        // Validation
        if (!email.trim()) {
            setError('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            // TODO: Implement your password reset API call here
            // const response = await passwordResetApi(email);

            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1500));

            toast.success('Password reset link sent to your email!', { autoClose: 3000 });

            // Navigate to a success page or back to login
            setTimeout(() => {
                navigate('/mobile/login');
            }, 2000);

        } catch (error) {
            console.error('Password reset error:', error);
            toast.error('Failed to send reset link. Please try again.');
            setError('Failed to send reset link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (error) {
            setError('');
        }
    };

    return (
        <main className="forgot-password dc-main">
            <div className="forgot-password container">
                <div className="forgot-password dc-haslayout">
                    <div className="forgot-password main-page-wrapper">
                        <div className="forgot-password row">
                            <div className="forgot-password col-lg-12 col-md-12">
                                <div className="forgot-password dc-modalcontent modal-content forgot_bodey">
                                    <div className="forgot-password dc-forgotformholds">
                                        {/* Back Button */}
                                        <button
                                            className="forgot-password back-button"
                                            onClick={() => navigate(-1)}
                                            aria-label="Go back"
                                        >
                                            <FaArrowLeft />
                                        </button>

                                        <div className='forgot-password dc-forgotformholds'>
                                            <div className='forgot-password dc-forgotform'>
                                                {/* Header with Logo */}
                                                <div className="forgot-password dc-forgotheader">
                                                    <div className="forgot-logo">
                                                        <ImageShow url={settings.favicon_url} height={0} width={0} />
                                                    </div>
                                                    <h1>Enter Your Email</h1>
                                                    <p className="welcome-message">
                                                        We'll send you a link to reset your password
                                                    </p>
                                                </div>

                                                {/* Forgot Password Form */}
                                                <form className="forgot-password dc-formtheme dc-forgotform" onSubmit={handleSubmit}>
                                                    <fieldset>
                                                        {/* Email Input */}
                                                        <div className="forgot-password form-group">
                                                            <label htmlFor="email">Email</label>
                                                            <input
                                                                id="email"
                                                                type="email"
                                                                name="email"
                                                                className={`forgot-password form-control ${error ? 'is-invalid' : ''}`}
                                                                placeholder="example@gmail.com"
                                                                value={email}
                                                                onChange={handleEmailChange}
                                                                autoFocus
                                                            />
                                                            {error && (
                                                                <div className="forgot-password invalid-feedback">
                                                                    {error}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Next Button */}
                                                        <button
                                                            type="submit"
                                                            className="forgot-password dc-btn"
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <>
                                                                    <span className="forgot-password spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                    Sending...
                                                                </>
                                                            ) : (
                                                                'Next'
                                                            )}
                                                        </button>
                                                    </fieldset>

                                                    {/* Sign In Link */}
                                                    <div className="forgot-password dc-forgotfooterinfo">
                                                        Remember your password? <Link to="/mobile/login">Sign In</Link>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ForgetPassword;

